import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import '../scss/index.scss';
const Toast = require('react-toast-mobile');

export default class StoreContact extends React.Component <any, any>  {
	constructor(props: any) {
		super(props);
		this.state = {
			companyId: this.props.location.state ? this.props.location.state.id : '', // 企业id
			storeContactArr: [],
			saleContactArr: [],
		}
	}

	componentDidMount() {
		this.getData();
	}

	render() {
		return (
			<div className="gray-bg">
				<div className="menu-list-warrper">
					<p className="menu-title">商铺负责人</p>
					<ul className="menu-list">
						{
							this.state.storeContactArr.map((v: any, k: number) => {
								return (
									<li className="item" key={k} onClick={() => {
										(this.props as any).history.push({
											pathname: '/store/contact/add',
											state: {
												companyId: this.state.companyId,
												id: v.id,
												type: 1,
												action: 'edit'
											}
										})
									}}>
										<span className="text">{v.contact}</span>
										<i className="right-icon"></i>
									</li>
								)
							})
						}
					</ul>
				</div>
				<div className="menu-list-warrper">
					<p className="menu-title">销售部</p>
					<ul className="menu-list">
						{
							this.state.saleContactArr.map((v: any, k: number) => {
								return (
									<li className="item" key={k} onClick={() => {
										(this.props as any).history.push({
											pathname: '/store/contact/add',
											state: {
												companyId: this.state.companyId,
												id: v.id,
												action: 'edit'
											}
										})
									}}>
										<span className="text">{v.contact}</span>
										<i className="right-icon"></i>
									</li>
								)
							})
						}
						<li className="item" onClick={() => this.addOne()}>
							<i className="add-icon"></i>
							<span className="text blue">新增联系人</span>
							<i className="right-icon"></i>
						</li>
					</ul>
				</div>

				{/*<div className="default-btn-warrper">
					<button className="default-btn">保存设置</button>
				</div>*/}
			</div>
		)
	}

	// 获取联系人数组
	private async getData() {
		
		const r = await request({
			method: "post",
			url: `${config.MALLAPI}api/shop/default/contact`,
			data: {
				companyId: this.state.companyId,
			}
		})

		if(r.error_code === 0) {
			this.setState({
				storeContactArr: r.data.shop,
				saleContactArr: r.data.sales
			})
		}

	}

	// 添加一个联系人
	private addOne() { 
		if (this.state.saleContactArr.length >= 3) { 
			return Toast.T.notify('销售部联系人最多只能添加3个');
		}
		this.props.history.push({
			pathname: '/store/contact/add',
			state: {
				companyId: this.state.companyId
			}
		})
	}
}